import React from 'react';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import './EventCard.css';

import { 
  Card,
  CardMedia,
  ClickAwayListener,
  IconButton,
  Tooltip,
  Box,
  Typography,
  CardContent,
  Paper,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

class EventCard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      openDateToolTip: false
    };
  }

  render() {
    const { dateTexts } = this.props;

    const date = dateTexts ? dateTexts.map(x => 
      <Box component='span' key={x} sx={{display:'inline-block'}}>
        {x}
      </Box>
    ) : null;

    return (
      <>
        <TimelineItem>
          <TimelineOppositeContent color="text.secondary">
            <Box component='div'>{date}</Box>
            {this.renderDateAdditionalInfo()}
          </TimelineOppositeContent>

          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>

          <TimelineContent>{this.renderContent()}</TimelineContent>
        </TimelineItem>
      </>
    );
  }

  private handleTooltipOpenClose = (open:boolean) => () => {
    this.setState({openDateToolTip: open});
  };

  protected renderDateAdditionalInfo(){
    const { dateAdditionalInfo } = this.props;
    return (
      dateAdditionalInfo ? (
        <ClickAwayListener onClickAway={this.handleTooltipOpenClose(false)}>
          <Box component='span'>
            <Tooltip
              title={dateAdditionalInfo}
              arrow
              open={this.state.openDateToolTip}
              onClose={this.handleTooltipOpenClose(false)}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <IconButton onClick={this.handleTooltipOpenClose(true)} sx={{padding:0}}>
                <InfoIcon/>
              </IconButton>
            </Tooltip>
          </Box>
        </ClickAwayListener>
      ) : null
    );
  }

  protected renderContent() {
    const { title, description, imgUrl, important, objectPosition } = this.props;
    const cardMedia = imgUrl ? this.renderCardMedia() : null;

    const colorStyle = important ? { backgroundColor: '#e0f2f1', border: 3, borderColor: '#00695c' } : null

    const positionStyle = objectPosition ? {
      '& .MuiCardMedia-root': {
        objectPosition: `100% ${objectPosition}`,
      },
    } : null;

    return (
      <Paper elevation={important ? 12 : 3} sx={{ maxWidth: 345, mb: 2 }}>
        <Card sx={{
          ...colorStyle,
          ...positionStyle,
        }}>
          {cardMedia}
          <CardContent>
            <Typography
              variant="h5"
              component="div"
              sx={{pb: 1, mb: 2, borderBottom: 1, borderColor: 'grey.500'}}>
              {title}
            </Typography>
            <Typography component="div">
              {description}
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    );
  }

  protected renderCardMedia() {
    const { quoteDomain, imgUrl, title } = this.props;

    const quoteDomainElm = quoteDomain ? (
      <small className='eventcard-quote'>
        {`(c)${quoteDomain}`}
      </small>
    ) : null;

    const cardMedia = (
      <div className='eventcard-media-wrapper'>
        <CardMedia
          component="img"
          image={imgUrl}
          alt={title}
          className='eventcard-media'
        />
        {quoteDomainElm}
      </div>
    );

    return cardMedia;
  }
}

type Props = {
  dateTexts?: string[],
  dateAdditionalInfo?: string,
  title: string,
  description: React.ReactNode,
  imgUrl?: string,
  quoteDomain?: string,
  important?: boolean,
  objectPosition?: string,
}

type State = {
  openDateToolTip: boolean,
}

export default EventCard;
